// Copied from the nowadays repo, packages/ui/src/components/textarea.tsx at 6da58398f. Change it there first, then copy it here, rewriting any em dash (this repo bans them).
"use client"

import * as React from "react"
import {
  composeRenderProps,
  TextArea as TextareaPrimitive,
} from "react-aria-components"

import { cn } from "@/nowadays-ui/lib/utils"

// DEVIATION: starts at three lines (min-h-24) instead of upstream's two (min-h-16). At two
// lines a one-line placeholder sat about midway down the box and read as centered text.
// DEVIATION: the placeholder keeps the textarea's line height (placeholder:leading-[inherit]).
// This repo's globals.scss sets `textarea::placeholder { line-height: 200% }` for every textarea,
// which dropped the placeholder below the cursor.
function Textarea({
  className,
  ...props
}: React.ComponentProps<typeof TextareaPrimitive>) {
  return (
    <TextareaPrimitive
      data-slot="textarea"
      className={composeRenderProps(className, (className) =>
        cn(
          "flex field-sizing-content min-h-24 w-full resize-none rounded-2xl border border-transparent bg-input/50 px-3 py-3 text-base transition-[color,box-shadow,background-color] outline-none placeholder:leading-[inherit] placeholder:text-muted-foreground focus-visible:border-ring focus-visible:ring-3 focus-visible:ring-ring/30 disabled:cursor-not-allowed disabled:opacity-50 aria-invalid:border-destructive aria-invalid:ring-3 aria-invalid:ring-destructive/20 md:text-sm dark:aria-invalid:border-destructive/50 dark:aria-invalid:ring-destructive/40",
          className
        )
      )}
      {...props}
    />
  )
}

// Re-exported so apps compose labeled fields without importing
// react-aria-components directly, TextField provides the label/control
// context, and a second RAC instance in the app would break that association.
export { TextField } from "react-aria-components"

export { Textarea }
